const initIntegration = (integration) => {
    const menuItems = integration.querySelectorAll('.integration__menu-item');
    const items = integration.querySelectorAll('.integration-element');
    menuItems.forEach((menuItem) => {
        menuItem.addEventListener('click', () => {
            menuItems.forEach((currentMenuItem) => currentMenuItem.classList.toggle('active', currentMenuItem === menuItem));
            if (!menuItem.dataset.category) {
                items.forEach((item) => item.classList.remove('hidden'));
                return;
            }
            items.forEach((item) => item.classList.toggle('hidden', !item.dataset.categories.split(',').includes(menuItem.dataset.category)));
        });
    });
};
export const initIntegrations = () => {
    document.querySelectorAll('.integration').forEach((integration) => {
        initIntegration(integration);
    });
};
